export enum OperationType {
    Addition,
    Multiplication,
    Division,
    Function,
    Compare,
    Binary,
    Subtraktion,
    None
}